import type { EServerErrorMsg } from '@loc/server/constant/errorCode'
import type { ProductsSubAppName, UsageSubUsageType } from '@prisma/client'
import type { AppTRPCClientError } from '@/utils/error'

export const unknownErrorMessage = 'UNKNOWN ERROR'

export function parseServerErrorMessage(errorMessage: string) {
  const segments = errorMessage.split('::')
  if (segments.length === 3) {
    return {
      appName: segments[0]! as ProductsSubAppName,
      usageType: segments[1]! as UsageSubUsageType,
      message: segments[2]! as EServerErrorMsg,
    }
  }

  return errorMessage || unknownErrorMessage
}

export function parseTrpcErrorMessage(error: AppTRPCClientError) {
  if (error.data?.code === 'FORBIDDEN') {
    return parseServerErrorMessage(error.message)
  }

  return error.message || unknownErrorMessage
}

export type TrpcErrorHandlerMiddleware = (
  ctx: {
    error: AppTRPCClientError
    parsedErrorMessage: ReturnType<typeof parseTrpcErrorMessage>
  },
  next: () => void,
) => void

export class GlobalTrpcErrorHandler {
  middlewares: TrpcErrorHandlerMiddleware[] = []

  use(middleware: TrpcErrorHandlerMiddleware) {
    this.middlewares.push(middleware)
  }

  handle(error: AppTRPCClientError) {
    const ctx = { error, parsedErrorMessage: parseTrpcErrorMessage(error) }

    for (const middleware of this.middlewares) {
      let breakFlag = true
      const next = () => {
        breakFlag = false
      }
      middleware(ctx, next)
      if (breakFlag) {
        break
      }
    }
  }
}
